// Conversations SCÉNARISÉES du joueur, toutes missions confondues — CCT-96.
//
// Pendant de `listUsChats`, qui ne rend que les fils ouverts par le MOTEUR (une US bloquée,
// refusée, validée). Celles-ci sont écrites par l'auteur dans le Story Builder.
//
// ⚠️ ELLES ÉTAIENT LISTÉES DEPUIS UN CATALOGUE BUNDLÉ, indexé par des identifiants de mission
// codés en dur. Ces identifiants diffèrent d'une plateforme à l'autre : la liste était donc
// fausse partout ailleurs qu'en local, et elle servait surtout de repli silencieux — l'écran
// montrait des conversations qui n'existaient pas sur la plateforme jouée.
import { apiFetch } from './client';

/** Résumé d'une conversation scénarisée pour le centre de messages. */
export interface ScriptedChatSummary {
  missionId: number;
  missionTitle: string | null;
  /** ⚠️ CHAÎNE : il transite par l'URL de navigation, où `3 === "3"` est faux (CCT-252). */
  itemId: string;
  title: string;
  characterName: string | null;
  /**
   * Identity of the character in the mission's cast — CCT-347.
   *
   * ⚠️ THIS IS WHAT ALLOWS GROUPING BY PERSON. Without it the message centre can only group on the
   * LABEL, and two spellings of one name make two people. `null` when the conversation names
   * somebody who is not in the cast: we then fall back on the name, for want of anything better.
   */
  characterId: number | null;
  /** Déjà résolue par le runtime — l'app n'a aucune règle d'URL à connaître. */
  avatarUrl: string | null;
  messageCount: number;
  /** Nombre de QUESTIONS : c'est la progression affichée, pas le nombre de répliques. */
  questionCount: number;
  lastMessage: string;
}

export const listScriptedChats = (token: string | null) =>
  apiFetch<{ chats: ScriptedChatSummary[]; count: number }>(
    '/me/stories/chats', { token, auth: true });
